// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import Vuex from 'vuex'
import axios from 'axios'
import VueAxios from 'vue-axios'

import './assets/csmar_theme/index.css'

Vue.use(Vuex)
Vue.config.productionTip = false
Vue.use(ElementUI)
Vue.use(VueAxios, axios)

/**
 * axios  配置
 */

axios.defaults.headers.post['Content-Type'] = 'application/json;charset=utf-8'
axios.defaults.headers.common['device-type'] = 'PC_CSMAR'
// http request 请求拦截器
// axios.interceptors.request.use(
//   config => {
//     if (config.method === 'post' || config.method === 'put') {
//       config.data =
//         config.data instanceof FormData
//           ? config.data
//           : JSON.stringify(config.data)
//       console.log(config.data)
//     }
//     return config
//   },
//   error => {
//     console.error('请求错误信息')
//     // 对请求错误做些什么
//     return Promise.reject(error)
//   }
// )

// http response 响应拦截器
axios.interceptors.response.use(
  response => {
    if (response.headers.userinfo) {
      localStorage.setItem('userinfo', decodeURI(response.headers.userinfo))
      store.commit('refreshUserInfo')
    }

    switch (response.data.code) {
      case 400:
        // store.commit('showLoginDialog')
        // process.env.VUE_APP_LOGIN_PAGE
        window.location.href = process.env.VUE_APP_LOGIN_PAGE
        break
      case 200:
        return response.data
      case 403:
        store.commit('showPayDialog', response.data && response.data.data)
        break
      case 201:
        if (response.data.msg) {
          ElementUI.Message({
            message: response.data.msg,
            type: 'error'
          })
        }
        return response.data
      default:
        ElementUI.Message({
          message: response.data.msg,
          type: 'error'
        })
    }
    return Promise.reject(response.data)
  },
  error => {
    if (error.response) {
      ElementUI.Message({
        message: '系统异常，错误码【' + error.response.status + '】',
        type: 'error'
      })
      return Promise.reject(error.response.data)
    }
  }
)

const moduleA = {
  state: {},
  mutations: {},
  actions: {},
  getters: {}
}

const store = new Vuex.Store({
  // 相当于vue  中的data
  state: {
    msg: 'hellow  vuex',
    loginDialogVisible: false,
    payDialogVisible: false,
    payResult: false,
    refeshUserPrice: true,
    refreshUserInfo: false,
    orgId: '-1'
  },
  // 相当于vue computed
  getters: {
    getMsg () {
      return store.state.msg + 'so good'
    }
  },
  // 相当于vue中的method
  mutations: {
    changeOrg: function (state, orgId) {
      console.log('切换了orgId---main.js' + this.orgId)
      state.orgId = orgId
    },
    addPreFix (state) {
      state.msg = 'msg:' + state.msg
    },
    showLoginDialog: function (state) {
      state.loginDialogVisible = !state.loginDialogVisible
    },
    showPayDialog: function (state, data) {
      state.payData = data
      state.payDialogVisible = !state.payDialogVisible
    },
    paySucsess: function (state) {
      state.payResult = !state.payResult
    },
    toFreshUserPrice: function (state) {
      state.refeshUserPrice = !state.refeshUserPrice
    },
    refreshUserInfo: function (state) {
      state.refreshUserInfo = !state.refreshUserInfo
    }
  },
  // 和mutations 类似，但是可以异步操作
  Actions: {},
  modules: {
    a: moduleA
  }
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: {
    App
  },
  template: '<App/>',
  render: h => h(App)
})



// WEBPACK FOOTER //
// ./src/main.js